import { definePlugin } from '@dundle/utils/nuxt';

export default definePlugin(({ app }) => {
    // Force strategy:
    const strategy = localStorage.getItem('ig_strategy');
    // app.store.state.auth.strategy = strategy;
});
